import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ColumnTypes } from "../../data-grid/data-grid.component";
import { ES_TYPE } from "../../services/elastic-search.service";
import { AbstractTransformerService, TRANSFORMER_STATE } from "../abstract-transformer.service";

@Injectable({ providedIn: "root" })
export class ColumnTypeService extends AbstractTransformerService {
  private _setTypes$ = new BehaviorSubject<string[]>([]); // types that have been overridden
  private _columnTypes$ = new BehaviorSubject<ColumnTypes | null>(null);

  public get columnTypes$(): Observable<ColumnTypes | null> {
    return this._columnTypes$.asObservable();
  }
  public get columnTypes(): ColumnTypes | null {
    return this._columnTypes$.getValue();
  }
  public set columnTypes(types: ColumnTypes | null) {
    this._columnTypes$.next(types);
  }

  public get setTypes$(): Observable<string[]> {
    return this._setTypes$.asObservable();
  }
  public get setTypes(): string[] {
    return this._setTypes$.getValue();
  }
  private setSetTypes(colIds: string[]) {
    this._setTypes$.next(colIds);
  }

  public setType(colId: string, type: ES_TYPE, format?: string) {
    if (this.state !== TRANSFORMER_STATE.EDITING) {
      if (this.state === TRANSFORMER_STATE.DONE) {
        this.setSetTypes([]);
      }
      this.state = TRANSFORMER_STATE.EDITING;
    }
    const types = { ...this.columnTypes };
    types[colId] = { type };
    if (format) {
      types[colId]["format"] = format;
    }
    this.columnTypes = types;

    const prevSet = this.setTypes;
    if (prevSet.indexOf(colId) < 0) {
      this.setSetTypes([...prevSet, colId]);
    }
  }

  public isSet(colId: string): boolean {
    return this.setTypes.indexOf(colId) >= 0;
  }

  override reset() {
    super.reset();
    this.setSetTypes([]);
    this.columnTypes = null;
  }
}
